import router from './router/index.js'
// import Vue from './vue'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken,getStroage } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import baseRoutesList from './router/baseRouter.js'

NProgress.configure({ showSpinner: false }) // NProgress Configuration


const whiteList = ['/login','/register','/agreement'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken =getStroage('token')

  if (hasToken) {
      // if is logged in, redirect to the home page
      next({ path: '/home' })
      NProgress.done()
  } else {
  
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
